import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { GLOBAL_CONFIG } from '../core/global-config.injection-token';
import { GlobalConfig } from '../interfaces/global-config.model';
import { KeycloakSetting } from './keycloak-setting.model';

@Injectable({ providedIn: 'root' })
export class KeycloakService {
  private basePath = '';
  private keycloakserviceUrl = 'frontend/keycloak'; // URL to web API
  private keycloakSetting: KeycloakSetting;

  constructor(private http: HttpClient, @Optional() @Inject(GLOBAL_CONFIG) globalConfig: GlobalConfig) {
    if (globalConfig && globalConfig.basePath) {
      this.basePath = globalConfig.basePath;
    }
    if (globalConfig && globalConfig.keycloakSettings) {
      this.keycloakSetting = globalConfig.keycloakSettings;
    }
  }

  public getKeycloakSetting(): KeycloakSetting {
    return this.keycloakSetting;
  }

  public loadKeycloakSetting(): Observable<any> {
    // We can get keycloak settings via global config that can be overrided dynamically by kubernetes or other. Thus one less backend call. :)
    if (this.keycloakSetting) {
      return of(this.keycloakSetting);
    } else {
      const options = { headers: new HttpHeaders() };
      options.headers = options.headers.set('Content-Type', 'application/json;charset=UTF-8');
      options.headers = options.headers.set('Accept', 'application/json;charset=UTF-8');
      return this.http.get(`${this.basePath}${this.keycloakserviceUrl}`, options);
    }
  }

  public load() {
    return this.loadKeycloakSetting().pipe(
      tap(response => {
        this.keycloakSetting = response;
      }),
      map(() => of(true))
    );
  }
}
